import React from 'react';
import NoneGiven from './none_given';
import DimensionsMissing from './dimensions_missing';
import SecondaryMissing from './secondary_missing';
import StatusbarConstants from '../../../../constants/statusbar_constants';
import { Filters } from '../../../../constants/filter/filters';

function currentStatusFactory(status, filters, postcodeExistsButNeedsToBeLoaded, displayDimensions, onChange) {
    switch (status) {
        case StatusbarConstants.ALL_MISSING:
            return <NoneGiven />;
        case StatusbarConstants.DIMENSIONS_MISSING:
            return <DimensionsMissing
                width={filters[Filters.WIDTH]}
                height={filters[Filters.HEIGHT]}
                diameter={filters[Filters.DIAMETER]}
            />;
        case StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING:
        case StatusbarConstants.SPEED_INDEX_MISSING:
        case StatusbarConstants.LOAD_INDEX_MISSING:
        case StatusbarConstants.TYRE_INDEX_MISSING:
        case StatusbarConstants.POSTCODE_MISSING:
        case StatusbarConstants.NONE_MISSING:
            return <SecondaryMissing
                filters={filters}
                postcodeExistsButNeedsToBeLoaded={postcodeExistsButNeedsToBeLoaded}
                displayDimensions={displayDimensions}
                onChange={onChange}
            />;
        default:
            return null;
    }
}

export default currentStatusFactory;
